export var FIRST_QUESTION_ID = 'Q12';
export var REDISPUTE_FIRST_QUESTION_ID = 'RQ01';
export var REDISPUTE_REVIEW_PREVIOUS_QUESTION_ID = 'RQ03';
export var RECURRING_TABLE_LIST_QUESTION_ID = 'Q140';
export var DOUBLE_CHARGE_QUESTION_ID = 'Q81';
export var VALIDATE_DATE_IDS = [
    // When did you return it
    'Q58',
    // Date of return
    'Q87',
    // What date was the order canceled
    'Q96',
    'Q131',
    // What date did you attempt to cancel
    'Q17'
];
//# sourceMappingURL=questionIds.js.map